export enum BasketPlanStatus {
  OPEN = 0,
  CONFIRMED = 1,
  DELIVERED = 2,
}